import { render, staticRenderFns } from "./Ambe.vue?vue&type=template&id=9967b352"
import script from "./Ambe.vue?vue&type=script&lang=js"
export * from "./Ambe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports